import { render, staticRenderFns } from "./champion-grid.vue?vue&type=template&id=f65cbb56&scoped=true&"
import script from "./champion-grid.ts?vue&type=script&lang=ts&"
export * from "./champion-grid.ts?vue&type=script&lang=ts&"
import style0 from "./champion-grid.vue?vue&type=style&index=0&id=f65cbb56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65cbb56",
  null
  
)

export default component.exports